import {
  FIRST_HEADER,
  FIRST_TITLE,
  AFPercent_HEADER,
  AFPercent_TITLE,
  LAST_HEADER,
  LAST_TITLE,
} from "stats/RoundStats";
import { DriverTrackStats } from "stats/Track/Driver/DriverTrackStats";
import { StatTableColumn } from "../../../StatTableColumn";
import {
  BEST_HEADER,
  BEST_TITLE,
  MEDIAN_HEADER,
  MEDIAN_TITLE,
  DNF_HEADER,
  DNF_TITLE,
} from "stats/TimeStats";
import { nonUndefined } from "Utility";
import {
  getRatingTitle,
  RATING_HEADERS,
  RatingType,
} from "stats/Rating/RatingTypes";

export const getSharedTrackDriverStatTableColumns = (
  ratingType: RatingType
): StatTableColumn<DriverTrackStats>[] => {
  return nonUndefined([
    {
      type: "OrgLogoName",
      sortable: true,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.driverName,
      smallerSize: true,
    },
    {
      type: "Number",
      header: RATING_HEADERS[ratingType],
      title: getRatingTitle(ratingType),
      sortable: true,
      valueGetter: (arg) => arg.driverRating,
      sortDescFirst: true,
      fractionDigits: 2,
    },
    {
      type: "Time",
      header: BEST_HEADER,
      title: BEST_TITLE,
      sortable: true,
      timeGetter: (arg) => arg.bestTime,
    },
    {
      type: "Time",
      header: MEDIAN_HEADER,
      title: MEDIAN_TITLE,
      sortable: true,
      timeGetter: (arg) => arg.medianTime,
    },
    {
      type: "Percent",
      header: AFPercent_HEADER,
      title: AFPercent_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.averageFinishPercentile,
      fractionDigits: 1,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: FIRST_HEADER,
      title: FIRST_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.firstRate,
      subTextGetter: (arg) => arg.firstBreakdown,
      fractionDigits: 1,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: LAST_HEADER,
      title: LAST_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.lastRate,
      subTextGetter: (arg) => arg.lastBreakdown,
      fractionDigits: 1,
      sortDescFirst: true,
    },
    // ctorStatTablePercentColumn({
    //   header: MISTAKE_HEADER,
    //   title: MISTAKE_TITLE,
    //   sortable: true,
    //   rateGetter: (arg) => arg.mistakeRate,
    //   subTextGetter: (arg) => arg.mistakeBreakdown,
    //   fractionDigits: 1,
    // }),
    // ctorStatTablePercentColumn({
    //   header: CRASH_HEADER,
    //   title: CRASH_TITLE,
    //   sortable: true,
    //   rateGetter: (arg) => arg.crashRate,
    //   subTextGetter: (arg) => arg.crashBreakdown,
    //   fractionDigits: 1,
    // }),
    {
      type: "Percent",
      header: DNF_HEADER,
      title: DNF_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.dnfRate,
      subTextGetter: (arg) => arg.dnfBreakdown,
      fractionDigits: 1,
      sortDescFirst: true,
    },
  ]);
};
